import React from 'react'
import { observable } from 'mobx'

const ErrorsContext = React.createContext(observable(new Map()))

export const Provider = ErrorsContext.Provider
export const Consumer = ErrorsContext.Consumer

export default ErrorsContext
